import script from "./task-report-table.vue?vue&type=script&setup=true&lang=js"
export * from "./task-report-table.vue?vue&type=script&setup=true&lang=js"

import "./task-report-table.vue?vue&type=style&index=0&id=7e880fa1&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e880fa1"]])

export default __exports__